export default __webpack_public_path__ + "static/media/ursus.59f48156.png";